import api from "./api";

const getArticles = async (lang, articteNumbers, articles) => {
  let _articles = [];
  api.articles
    .list(null, {
      contentIds: articteNumbers,
      lang: lang
    })
    .then(res => {
      let knowledgeArticleList = res.knowledgeArticleList ? res.knowledgeArticleList : [];

      knowledgeArticleList.forEach(item => {
        let linkObj = articles.filter(x => x.fields.articleNumber?.value === item.articlePublicNumber)[0]?.fields?.link;

        let articleObject = {
          title: item.title,
          link: {
            value: {
              ...linkObj?.value,
              href: `${linkObj?.value?.href}#${item.articlePublicNumber}`
            }
          }
        };

        _articles.push(articleObject);
      });
    });
  return _articles;
};

export default getArticles;
